import {TrueGrit} from "../TrueGrit";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {gsap} from "gsap";
import {ISymbol} from "../../core/reel/ReelInterfaces";
import {TrueGritStatics} from "../TrueGritStatics";
import {ArrayUtils} from "../utils/ArrayUtils";
import {TrueGritStackedWildSymbol} from "./TrueGritStackedWildSymbol";

export enum TrueGritSymbolStates {
    NORMAL,
    SPIN,
    NO_WIN,
    LANDING,
    COLLAPSE_LANDING,
    SPIN_HORIZONTAL,
    SPIN_IN,
    SPIN_OUT,
}

export class TrueGritSymbol extends PIXI.Container implements ISymbol {
    private _symbolName:string;
    private _reelPosition:number;
    private _reelTargetPosition:number;
    private _reelId:number;
    protected _isRemoved:boolean;
    private _topChild:PIXI.Sprite;
    private _topChildRemoved:boolean;
    private _transformed:boolean;
    protected _splitLevel:number = 0;

    public state:TrueGritSymbolStates;

    protected _currentStateSprite:PIXI.Sprite;
    protected _newStateSprite:PIXI.Sprite;

    public wasTransformed:boolean = false;

    constructor(symbolName:string) {
        super();
        this.isRemoved = false;
        this._topChildRemoved = true;
        this._currentStateSprite = new PIXI.Sprite();
        this._currentStateSprite.name = "currentStateSprite";
        this._currentStateSprite.position.set(72, 72);
        this._currentStateSprite.anchor.set(0.5, 0.5);
        this._newStateSprite = new PIXI.Sprite();
        this._newStateSprite.name = "newStateSprite";
        this._newStateSprite.position.set(72, 72);
        this._newStateSprite.anchor.set(0.5, 0.5);
        this._newStateSprite.alpha = 0;

        if(symbolName == undefined) {
            console.warn("This should not be undefined!");
            symbolName = "L1"
        }
        this._symbolName = symbolName;
        this.resetPosition();
        this.addChild(this._newStateSprite);
        this.addChild(this._currentStateSprite);
    }

    public static isLowWin(symName:string){
        if (symName == "L1" || symName == "L2" || symName == "L3" || symName == "L4" || symName == "L5"){
            return true;
        }
        return false;
    }

    public static getSymbolPositionTweak(symbolName:string):PIXI.Point {
        const position = new PIXI.Point();
        if(symbolName == "M1") {
            position.y -= 2;
        } else if(symbolName == "M2") {
            position.x -= 2;
        } else if(symbolName == "M4") {
            position.x += 2;
        } else if(symbolName == "M3") {
            position.x -= 2;
            position.y -= 3;
        }

        return position;
    }

    public init(initState:TrueGritSymbolStates):TrueGritSymbol {
        this.getStateAnimation(initState);
        return this;
    }

    public getSplitAnimation(newSplitLevel:number, isBottomReel:boolean = false):gsap.core.Timeline {
        const splitTL:gsap.core.Timeline = gsap.timeline();
        let reelId:number = this._reelId;
        let row:number = this.reelPosition - 1;

        if(isBottomReel == true) {
            row = 3;
            reelId = this.reelPosition + 1;
        }
        if(this._symbolName == "L1" || this._symbolName == "L2" || this._symbolName == "L3" || this._symbolName == "L4" || this._symbolName == "L5") {
            splitTL.add([
                TrueGrit.splitSymbolView.getLowSplitAnimation(newSplitLevel, this.symbolName, reelId, row, false, false),
                gsap.to(this._currentStateSprite, {
                    duration : 0.13,
                    alpha : 0,
                    ease : "power2.in",
                    delay : 0.13
                })
            ]);
            splitTL.add([
                () => {this._splitLevel = newSplitLevel},
                () => {this.setState(TrueGritSymbolStates.NORMAL, "")},
                () => {this._currentStateSprite.alpha = 1}
            ], "-=0.1");
        }
        else if(this._symbolName == "M1" || this._symbolName == "M2" || this._symbolName == "M3" || this._symbolName == "M4" || this._symbolName == "M5") {
            splitTL.add([
                gsap.timeline({delay : 0.13}).add(() => {this._currentStateSprite.alpha = 0}),
                TrueGrit.splitSymbolView.getMidSplitAnimation(this.splitLevel, newSplitLevel, this.symbolName, reelId, row, false, false)
            ])
            ;
            splitTL.add([
                () => {this._splitLevel = newSplitLevel},
                () => {this.setState(TrueGritSymbolStates.NORMAL, "")},
                () => {this._currentStateSprite.alpha = 1}
            ], "-=0.1");
        }
        else if(this._symbolName == "W") {
            splitTL.add([
                gsap.timeline({delay : 0.13}).add(() => {this._currentStateSprite.alpha = 0}),
                TrueGrit.splitSymbolView.getWildSplitAnimation(this.splitLevel, newSplitLevel, this.symbolName, reelId, row)
            ])
            ;
            splitTL.add([
                () => {this._splitLevel = newSplitLevel},
                () => {this.setState(TrueGritSymbolStates.NORMAL, "")},
                () => {this._currentStateSprite.alpha = 1}
            ], "-=0.1");
        }
        else {
            splitTL.add(() => {this._splitLevel = newSplitLevel});
            splitTL.add(() => {this.setState(TrueGritSymbolStates.NORMAL, "")});
        }

        return splitTL;
    }

    public getSplitAndChangeAnimation(newSplitLevel:number, newSymbol:string, isBottomReel:boolean, isInfectious:boolean):gsap.core.Timeline {
        const splitTL:gsap.core.Timeline = gsap.timeline();
        let reelId:number = this._reelId;
        let row:number = this.reelPosition - 1;

        if(isBottomReel == true) {
            row = 3;
            reelId = this.reelPosition + 1;
        }

        if(newSymbol == "L1" || newSymbol == "L2" || newSymbol == "L3" || newSymbol == "L4" || newSymbol == "L5") {
            splitTL.add(() => {this._splitLevel = newSplitLevel});
            splitTL.add([
                TrueGrit.splitSymbolView.getLowSplitAnimation(newSplitLevel, newSymbol, reelId, row, true, isInfectious),
                gsap.to(this._currentStateSprite, {
                    duration : 0.13,
                    alpha : 0,
                    ease : "power2.in",
                    delay : 0.13
                })
            ]);
            splitTL.add([
                () => {this._symbolName = newSymbol},
                () => this.setState(TrueGritSymbolStates.NORMAL, ""),
                () => this._currentStateSprite.alpha = 1
            ], "-=0.1");
        } else if(newSymbol == "M1" || newSymbol == "M2" || newSymbol == "M3" || newSymbol == "M4" || newSymbol == "M5") {
            splitTL.add(() => {this._splitLevel = newSplitLevel});
            splitTL.add([
                gsap.timeline({delay : 0.13}).add(() => {this._currentStateSprite.alpha = 0}),
                TrueGrit.splitSymbolView.getMidSplitAnimation(this.splitLevel, newSplitLevel, newSymbol, reelId, row, true, isInfectious)
            ])
            ;
            splitTL.add([
                () => {this._symbolName = newSymbol},
                () => this.setState(TrueGritSymbolStates.NORMAL, ""),
                () => this._currentStateSprite.alpha = 1
            ], "-=0.1");
        }
        return splitTL;
    }

    public animateCollapse():gsap.core.Timeline {
        const timeline:gsap.core.Timeline = gsap.timeline();
        timeline.add(gsap.to(this.position, {
            duration : 0.1 * (this.reelTargetPosition - this.reelPosition),
            y : TrueGritStatics.symbolHeight * (this.reelTargetPosition - 1) + 1, // #363, #437
            ease : "power3.in"
        }));
        // #363, #437
        timeline.add(gsap.to(this.position, {
            duration: 0.03,
            y: TrueGritStatics.symbolHeight * (this.reelTargetPosition - 1) - 2,
            ease: "none"
        }));
        timeline.add(gsap.to(this.position, {
            duration: 0.05,
            y: TrueGritStatics.symbolHeight * (this.reelTargetPosition - 1),
            ease: "none"
        }));
        return timeline;
    }

    protected setState(state:TrueGritSymbolStates, textureName:string, changeSpeed:number = 0):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {this.state = state});
        tl.add(() => this.setNewStateSpriteTexture(textureName));

        tl.add([
            gsap.to(this._currentStateSprite, {
                duration : changeSpeed,
                alpha : 0,
                ease : "power2.in"
            }),
            gsap.to(this._newStateSprite, {
                duration : changeSpeed,
                alpha : 1,
                ease : "power2.out"
            })
        ]);
        tl.add([
            () => {this._currentStateSprite.texture = this._newStateSprite.texture},
            () => this._currentStateSprite.alpha = 1,
            () => this._newStateSprite.alpha = 0
        ]);

        return tl;
    }

    public resetPosition():void {
        this._currentStateSprite.position.set(72, 72);
        this._newStateSprite.position.set(72, 72);

        const posTweak = TrueGritSymbol.getSymbolPositionTweak(this._symbolName)
        this._currentStateSprite.position.x += posTweak.x;
        this._newStateSprite.position.x += posTweak.x;
        this._currentStateSprite.position.y += posTweak.y;
        this._newStateSprite.position.y += posTweak.y;
    }

    public setCurrentStateSpriteTexture(textureName:string = "") {
        let transformedString = "";
        if(this.transformed == true) {
            transformedString = "_transformed";
        }
        let splitLevelString = "";
        if(this.splitLevel > 1) {
            splitLevelString = "_split_0" + this.splitLevel;
        }
        if(textureName == "none") {
            this._currentStateSprite.texture = PIXI.Texture.EMPTY;
        } else {
            this._currentStateSprite.texture = TrueGrit.assetLoader.getTextures(TrueGritGameAssets.getSymbolStateTexturePath(this._symbolName, splitLevelString + textureName + transformedString))[0];
        }
    }

    public setNewStateSpriteTexture(textureName:string = "") {
        let transformedString = "";
        if(this.transformed == true) {
            transformedString = "_transformed";
        }
        let splitLevelString = "";
        if(this.splitLevel > 1) {
            splitLevelString = "_split_0" + this.splitLevel;
        }
        if(textureName == "none") {
            this._newStateSprite.texture = PIXI.Texture.EMPTY;
        } else {
            this._newStateSprite.texture = TrueGrit.assetLoader.getTextures(TrueGritGameAssets.getSymbolStateTexturePath(this._symbolName, splitLevelString + textureName + transformedString))[0];
        }
    }

    public getStateAnimation(state:TrueGritSymbolStates, changeSpeed:number = 0):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(this.state == state) {
            return tl;
        }

        if(this._symbolName !== "S") {
            if((state == TrueGritSymbolStates.SPIN_IN || state == TrueGritSymbolStates.SPIN_OUT)) {
                state = TrueGritSymbolStates.SPIN;
            }
            if(state == TrueGritSymbolStates.COLLAPSE_LANDING) {
                state = TrueGritSymbolStates.LANDING;
            }
        }

        switch(state) {
            case TrueGritSymbolStates.NORMAL:
                tl.add(this.setState(state, ""));
                break;
            case TrueGritSymbolStates.SPIN:
                let textureNameSpin:string = "_spin";
                tl.add(this.setState(state, textureNameSpin, changeSpeed));
                break;
            case TrueGritSymbolStates.SPIN_HORIZONTAL:
                let textureNameSpinHorizontal:string = "_spin-horizontal";
                tl.add(this.setState(state, textureNameSpinHorizontal, changeSpeed));
                break;
            case TrueGritSymbolStates.LANDING:
                tl.add(this.setState(state, "", changeSpeed));
                break;
            case TrueGritSymbolStates.COLLAPSE_LANDING:
                tl.add(this.setState(state, "_land", changeSpeed));
                break;
            case TrueGritSymbolStates.SPIN_IN:
                tl.add(this.setState(state, "_spinIn", changeSpeed));
                break;
            case TrueGritSymbolStates.SPIN_OUT:
                let textureNameSpinOut:string = "_spinOut";
                tl.add(this.setState(state, textureNameSpinOut, changeSpeed));
                break;
            case TrueGritSymbolStates.NO_WIN:
                tl.add(gsap.to(this, {
                    duration : 0.3,
                    pixi : {alpha : 1, saturation : 0, combineCMF : false, brightness : 0.5}
                }));
                break;
            default:

        }

        if(tl.duration() == 0) {
            tl.add(gsap.to(this, {duration : 0.0001}));
        }

        return tl;
    }

    public hideSymbol(shouldHide:boolean):void {
        if(shouldHide == true) {
            this._currentStateSprite.visible = false;
            this._newStateSprite.visible = false;
        } else {
            this._currentStateSprite.visible = true;
            this._newStateSprite.visible = true;
        }
    }

    public getShakeAnimation(duration:number = 1.715):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const wiggles = ArrayUtils.shuffleArray([TrueGritStatics.bigWinAnticipationWiggle, TrueGritStatics.bigWinAnticipationWiggle2]);
        const x = Math.random() > 0.5 ? "-=2" : "+=2";
        const y = Math.random() > 0.5 ? "-=1" : "+=1";
        const rotPostFix: string = (this instanceof TrueGritStackedWildSymbol ? "0.01" : "0.03"),
            rot = Math.random() > 0.5 ? "-=" + rotPostFix : "+=" + rotPostFix;

        tl.add(gsap.to(this.position, {
            duration : duration,
            x : x,
            ease : wiggles[0]
        }));
        tl.add(gsap.to(this.position, {
            duration : duration,
            y : y,
            ease : wiggles[1]
        }), "<");
        tl.add(gsap.to(this.currentStateSprite, {
            duration : duration,
            rotation : rot,
            ease : wiggles[1]
        }), "<");

        return tl.reverse();
    }

    public getM0HitShakeAnimation(hitTimesX: number):gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            x: string = Math.random() > 0.5 ? "-=2" : "+=2",
            y: string = Math.random() > 0.5 ? "-=1" : "+=1",
            rotPostFix: string = (this instanceof TrueGritStackedWildSymbol ? "0.01" : "0.03"),
            rot = Math.random() > 0.5 ? "-=" + rotPostFix : "+=" + rotPostFix;

        let wiggles,
            duration: number;

        if (hitTimesX <= 100) {
            duration = 1.2;
            wiggles = TrueGritStatics.m0Hit100Wiggle;
        } else if (hitTimesX <= 500) {
            wiggles = TrueGritStatics.m0Hit500Wiggle;
            duration = 1.425;
        } else {
            wiggles = TrueGritStatics.m0HitMoreThan500Wiggle;
            duration = 2;
        }

        tl.add(gsap.to(this.position, {
            duration : duration,
            x : x,
            ease : wiggles
        }));
        tl.add(gsap.to(this.position, {
            duration : duration,
            y : y,
            ease : wiggles
        }), "<");
        tl.add(gsap.to(this.currentStateSprite, {
            duration : duration,
            rotation : rot,
            ease : wiggles
        }), "<");

        return tl.reverse();
    }

    get currentStateSprite():PIXI.Sprite {
        return this._currentStateSprite;
    }

    get symbolName():string {
        return this._symbolName;
    }

    set symbolName(value:string) {
        this._symbolName = value;
    }

    get reelPosition():number {
        return this._reelPosition;
    }

    set reelPosition(value:number) {
        this._reelPosition = value;
    }

    get reelId():number {
        return this._reelId;
    }

    set reelId(value:number) {
        this._reelId = value;
    }

    get reelTargetPosition():number {
        return this._reelTargetPosition;
    }

    set reelTargetPosition(value:number) {
        this._reelTargetPosition = value;
    }

    get isRemoved():boolean {
        return this._isRemoved;
    }

    set isRemoved(value:boolean) {
        this._isRemoved = value;
    }

    get topChild():PIXI.Sprite {
        return this._topChild;
    }

    public removeTopChild():void {
        this.removeChild(this._topChild);
        this._topChildRemoved = true;
    }

    set topChild(value:PIXI.Sprite) {
        // #480 -> added safe check, if item is not there, we shouldn't add it to stage/view.
        if (value) {
            this.addChild(value);
            this._topChild = value;
            this._topChildRemoved = false;
        }
    }

    get splitLevel():number {
        return this._splitLevel;
    }

    set splitLevel(value:number) {
        if(value < 2) {
            return;
        }
        this._splitLevel = value;
    }

    public forceSetSplitLevel(value:number) {
        this._splitLevel = value;
    }

    get topChildRemoved():boolean {
        return this._topChildRemoved;
    }

    get transformed():boolean {
        return this._transformed;
    }

    set transformed(value:boolean) {
        this._transformed = value;
    }
}